<adapt-button-toggle-group adaptToolbarContent
                           alignment="center"
                           [value]="page"
                           (valueChange)="updateUrl($event)">
    @for (tab of tabs; track tab) {
        @if (tab.visible) {
            <button [adaptToggleGroupButton]="tab.toggleValue"
                    [adaptButtonIcon]="tab.icon">
                {{ tab.text }}
            </button>
        }
    }
</adapt-button-toggle-group>

@if (page !== ActivityPage.Calendar) {
    <adapt-two-column-layout [fullPage]="true"
                             leftColumnWidthClasses="col p-0 d-flex flex-column"
                             rightColumnWidthClasses="col-auto">
        @if (page === ActivityPage.Pathway) {
            <div left-column
                 class="p-3">
                <ng-container *ngTemplateOutlet="contentBefore"></ng-container>
                <ng-container *ngTemplateOutlet="activityBefore"></ng-container>
                <adapt-workflows-dashboard-element [person]="currentPerson"></adapt-workflows-dashboard-element>
                <ng-container *ngTemplateOutlet="activityAfter"></ng-container>
                <ng-container *ngTemplateOutlet="contentAfter"></ng-container>
            </div>
        }
        @if (page === ActivityPage.Status) {
            <ng-container left-column>
                <ng-container *ngTemplateOutlet="contentBefore"></ng-container>
                @if (!activitiesService.hasAnyActivityType) {
                    <p class="p-3">
                        There are no activities available for you at this moment.
                        <ng-container *adaptIfAlto="true">Try completing some pathways first.</ng-container>
                    </p>
                }
                @if (!hasAnyVisibleStatuses) {
                    <p class="p-3">There are no activities matching the current filter.</p>
                }
                <adapt-layout-manager class=""
                                      innerClass="h-100 pt-3 m-0 activity-layout"
                                      dynamicColumnClass="col-sm-12"
                                      page="activity-status"
                                      [fullPage]="true"
                                      [allowEditing]="true"
                                      [columnSizePresets]="columnSizePresets"
                                      [componentSizePresets]="componentSizePresets"
                                      *adaptRerender="updateLayout$">
                    <adapt-layout-column class="col-md-12">
                        <ng-container *ngTemplateOutlet="errorAlert"></ng-container>
                        @for (section of StatusSections; track statusSectionTrackBy($index, section)) {
                            @if (activitiesService.isActivityStatusVisible(section.group)) {
                                <adapt-layout-component id="activity-{{ section.group.toLowerCase() }}">
                                    <adapt-activity-section-collapsible [section]="section"
                                                                        [count]="section.displayedCount"
                                                                        [totalCount]="section.totalCount"
                                                                        [countTooltip]="activitySectionTooltip"
                                                                        fallbackText="Great work, you have nothing that is {{ section.group }}."
                                                                        [isLoading]="anySectionIsLoading">
                                        @if (activitiesService.asStatusGroupRecord(activitiesGroupedByStatus?.[section.group] | keyvalue); as activityStatusGroup) {
                                            @for (group of activityStatusGroup; track keyValueTrackBy($index, group)) {
                                                @if (CulturalActivityMetadataByType[group.key]; as typeMetadata) {
                                                    @if (group.value.length > 0 && activitiesService.isActivityTypeVisible(typeMetadata)) {
                                                        <adapt-universal-dashboard-element [name]="typeMetadata.title"
                                                                                           [background]="false"
                                                                                           [nested]="true"
                                                                                           [url]="routes[group.key]"
                                                                                           id="activity-{{ typeMetadata.type.toLowerCase() }}">
                                                            <div class="d-flex flex-row flex-wrap gap-3">
                                                                @for (activity of group.value; track activityTrackBy($index, activity)) {
                                                                    <ng-container *ngTemplateOutlet="
                                                                            activityTemplate;
                                                                            context: {
                                                                                $implicit: activity,
                                                                                highlight: false,
                                                                            }
                                                                        "></ng-container>
                                                                }
                                                            </div>
                                                        </adapt-universal-dashboard-element>
                                                    }
                                                }
                                            }
                                        }
                                    </adapt-activity-section-collapsible>
                                </adapt-layout-component>
                            }
                        }
                    </adapt-layout-column>
                </adapt-layout-manager>
                <ng-container *ngTemplateOutlet="contentAfter"></ng-container>
            </ng-container>
        }
        @if (page === ActivityPage.Activity) {
            <ng-container left-column>
                <ng-container *ngTemplateOutlet="contentBefore"></ng-container>
                @if (!activitiesService.hasAnyActivityType) {
                    <p class="p-3">
                        There are no activities available for you at this moment.
                        <ng-container *adaptIfAlto="true">Try completing some pathways first.</ng-container>
                    </p>
                }
                @if (!hasAnyVisibleTypes) {
                    <p class="p-3">There are no activities matching the current filter.</p>
                }
                <adapt-layout-manager innerClass="h-100 pt-3 m-0 activity-layout"
                                      page="activity"
                                      [fullPage]="true"
                                      [allowEditing]="true"
                                      [columnSizePresets]="columnSizePresets"
                                      [componentSizePresets]="componentSizePresets"
                                      *adaptRerender="updateLayout$">
                    @for (column of ActivityColumns; track column; let columnCount = $count) {
                        <adapt-layout-column class="col-lg-{{ columnCount > 1 ? 6 : 12 }}">
                            @for (section of column; track sectionTrackBy($index, section)) {
                                @if (activitiesService.isActivityTypeVisible(section) && notVisionsOrHasVisionTasks(section)) {
                                    <adapt-layout-component id="activity-{{ section.type.toLowerCase() }}">
                                        @if (section.isCulturalActivityType) {
                                            @if (activitiesGroupedByType?.[section.type]; as activities) {
                                                <adapt-activity-section-collapsible [section]="section"
                                                                                    [count]="getDisplayedCountForGroup(activities)"
                                                                                    [totalCount]="activities.totalCount"
                                                                                    [countTooltip]="activitySectionTooltip"
                                                                                    [fallbackText]="getFallbackText(section)"
                                                                                    [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                                    [error]="sectionError.get(section.type)">
                                                    @if (activities.overdue.length > 0 && activitiesService.isActivityStatusVisible(ActivityStatus.Overdue)) {
                                                        <adapt-universal-dashboard-element name="Activities due"
                                                                                           [background]="false"
                                                                                           [nested]="true">
                                                            <div class="d-flex flex-row flex-wrap gap-3">
                                                                @for (activity of activities.overdue; track activityTrackBy($index, activity)) {
                                                                    <ng-container *ngTemplateOutlet="
                                                                            activityTemplate;
                                                                            context: {
                                                                                $implicit: activity,
                                                                                highlight: true,
                                                                            }
                                                                        "></ng-container>
                                                                }
                                                            </div>
                                                        </adapt-universal-dashboard-element>
                                                    }
                                                    @if (activities.upcoming.length > 0 && activitiesService.isActivityStatusVisible(ActivityStatus.Upcoming)) {
                                                        <adapt-universal-dashboard-element name="Upcoming"
                                                                                           [background]="false"
                                                                                           [nested]="true">
                                                            <div class="d-flex flex-row flex-wrap gap-3">
                                                                @for (activity of activities.upcoming; track activityTrackBy($index, activity)) {
                                                                    <ng-container *ngTemplateOutlet="
                                                                            activityTemplate;
                                                                            context: {
                                                                                $implicit: activity,
                                                                                highlight: false,
                                                                            }
                                                                        "></ng-container>
                                                                }
                                                            </div>
                                                        </adapt-universal-dashboard-element>
                                                    }
                                                </adapt-activity-section-collapsible>
                                            }
                                        } @else {
                                            @if (section.type === NonCulturalActivityType.Visions) {
                                                @let activities = activitiesService.isVisionGroup(activitiesGroupedByType[section.type], section.type);
                    @if (activities) {
                                                    <adapt-personal-vision-activity-section [activityGroup]="activities"
                                                                                            [countTooltip]="activitySectionTooltip"
                                                                                            [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                                            [error]="sectionError.get(section.type)"
                                                                                            [fallbackText]="getFallbackText(section)"></adapt-personal-vision-activity-section>
                                                }
                                            }
                                            @if (section.type === NonCulturalActivityType.Actions && activitiesService.isItemGroup(activitiesGroupedByType?.[section.type], section.type); as activities) {
                                                <adapt-personal-work-activity-section [activityGroup]="activities"
                                                                                      [countTooltip]="activitySectionTooltip"
                                                                                      [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                                      [(blurPrivateActions)]="blurPrivateActions"
                                                                                      [error]="sectionError.get(section.type)"
                                                                                      [fallbackText]="getFallbackText(section)"></adapt-personal-work-activity-section>
                                            }
                                            @if (section.type === NonCulturalActivityType.Objectives && activitiesService.isObjectiveGroup(activitiesGroupedByType?.[section.type], section.type); as activities) {
                                                <adapt-personal-objectives-activity-section [activityGroup]="activities"
                                                                                            [countTooltip]="activitySectionTooltip"
                                                                                            [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                                            [error]="sectionError.get(section.type)"
                                                                                            [fallbackText]="getFallbackText(section)"></adapt-personal-objectives-activity-section>
                                            }
                                            @if (section.type === NonCulturalActivityType.Meetings && activitiesService.isMeetingGroup(activitiesGroupedByType?.[section.type], section.type); as activities) {
                                                <adapt-personal-meetings-activity-section [activityGroup]="activities"
                                                                                          [countTooltip]="activitySectionTooltipNotClickable"
                                                                                          [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                                          [error]="sectionError.get(section.type)"
                                                                                          [fallbackText]="getFallbackText(section)"></adapt-personal-meetings-activity-section>
                                            }
                                        }
                                    </adapt-layout-component>
                                }
                            }
                        </adapt-layout-column>
                    }
                </adapt-layout-manager>
                <ng-container *ngTemplateOutlet="contentAfter"></ng-container>
            </ng-container>
        }
    </adapt-two-column-layout>
}

@if (page === ActivityPage.Calendar) {
    @if (page === ActivityPage.Calendar) {
        <adapt-activity-calendar [activityTemplate]="activityTemplate"
                                 [routes]="routes"
                                 [shouldUpdate$]="shouldUpdate$">
            <ng-container *ngTemplateOutlet="contentBefore"></ng-container>
            <ng-container *ngTemplateOutlet="errorAlert"></ng-container>
        </adapt-activity-calendar>
    }
}
@if (page !== ActivityPage.Pathway) {
    <adapt-activity-filter [isCalendarView]="page === ActivityPage.Calendar"
                           (filterChange)="onFilterChanged($event)"></adapt-activity-filter>
}

<ng-template #activityTemplate
             let-activity
             let-highlight="highlight"
             let-actionable="actionable">
    @if (activitiesService.isCulturalActivity(activity)) {
        <adapt-activity-card [activity]="activity"
                             [highlightOverdue]="highlight"
                             [allowActions]="actionable ?? true"
                             (activityComplete)="onActivityCompleted(activity)"></adapt-activity-card>
    }

    @if (activitiesService.isItem(activity)) {
        <adapt-kanban-card [item]="activity"
                           [highlight]="highlight"
                           [blurSensitiveContent]="blurPrivateActions"
                           [draggable]="false"
                           [showAssignee]="false"></adapt-kanban-card>
    }

    @if (activitiesService.isVisionTeam(activity)) {
        <adapt-personal-vision-activity-card [team]="activity"></adapt-personal-vision-activity-card>
    }

    @if (activitiesService.isMeeting(activity)) {
        <adapt-meeting-dashboard-card [meeting]="activity"
                                      [showTeamName]="true"
                                      [compact]="false"
                                      [showStartButton]="actionable ?? true"></adapt-meeting-dashboard-card>
    }

    @if (activitiesService.isMeetingTeamGroup(activity)) {
        <div>
            <adapt-link-team-meetings-page *adaptIfAlto="false"
                                           [team]="activity.team"
                                           class="d-block mb-1"></adapt-link-team-meetings-page>
            <div class="d-flex flex-column flex-wrap gap-3">
                @for (meeting of activity.meetings; track meeting) {
                    <adapt-meeting-dashboard-card [meeting]="meeting"
                                                  [showTeamName]="false"
                                                  [compact]="false"></adapt-meeting-dashboard-card>
                }
            </div>
        </div>
    }

    @if (activitiesService.isObjective(activity)) {
        <adapt-objective-dashboard-summary [objective]="activity"
                                           [displayAssignee]="false"
                                           [class.overdue]="activity.isOverdue && highlight"></adapt-objective-dashboard-summary>
    }
    @if (activitiesService.isObjectiveTeamGroup(activity)) {
        <div>
            <adapt-link-objectives-page *adaptIfAlto="false"
                                        [team]="activity.team"
                                        class="d-block mb-1"></adapt-link-objectives-page>
            <div class="d-flex flex-column flex-wrap gap-3">
                @for (objective of activity.objectives; track objective) {
                    <adapt-objective-dashboard-summary [objective]="objective"
                                                       [displayAssignee]="false"
                                                       [class.overdue]="objective.isOverdue && highlight"></adapt-objective-dashboard-summary>
                }
            </div>
        </div>
    }
</ng-template>

<ng-template #contentBefore>
    <ng-content select="[activity-page-before]"></ng-content>
</ng-template>

<ng-template #contentAfter>
    <ng-content select="[activity-page-after]"></ng-content>
</ng-template>

<ng-template #activityBefore>
    <ng-content select="[activity-pathway-page-before]"></ng-content>
</ng-template>

<ng-template #activityAfter>
    <ng-content select="[activity-pathway-page-after]"></ng-content>
</ng-template>

<ng-template #errorAlert>
    @if (hasAnyErrors) {
        <div class="alert alert-danger"
             role="alert">
            There was a problem loading the following activities:
            <ul>
                @for (errorGroup of groupedErrors; track errorGroup) {
                    <li>
                        <b>{{ errorGroup.items.join(", ") }}:</b>
                        {{ errorGroup.key }}
                    </li>
                }
            </ul>
        </div>
    }
</ng-template>
